/**
 * Created by SH: 02/20/2020
 */

import {  gsap } from "gsap";
import { Helper } from "../utils/Helper";
import { ReelState } from "./ReelEngineView";
import { ArrayHelper } from "../utils/ArrayHelper";
import { ReelEngineController } from "./ReelEngineController";
import { IDurationConfig, IReelConfig } from "./IData/IReelData";
import { IDimOrientation, ResizeHelper, LayoutDimData } from "../utils/ResizeHelper";
import { MathHelper } from "../utils/MathHelper";

export class ReelEngineManager extends PIXI.Container {

    protected static readonly reelDim:IDimOrientation = {
        landscape :{
            scale:      new PIXI.Point(1,1),
            position:   new PIXI.Point(0,0),
        },
        portrait :{
            scale:      new PIXI.Point(1,1),
            position:   new PIXI.Point(0,0)
        }
    };

    protected reelConfig:IReelConfig;

    protected static durations:IDurationConfig;
    protected static _reels:ReelEngineController[] = [];

    protected static stopOrder:number[];
    protected static stopOrderIndx:number = 0;
 
    public static get AllReels():ReelEngineController[]{ return this._reels; };
    public get AllReels():ReelEngineController[]{ return ReelEngineManager.AllReels; };

    public get dim():LayoutDimData{ return ReelEngineManager.dim; };
    public static get dim():LayoutDimData{ return ResizeHelper.calcDim(this.reelDim); };

    private static stopDelays: number[] = [];
    private static jurisdiction_time_calculator:(value:number) => number;

    public static get isSpinning():boolean{ return this.findReelWithState(ReelState.STEP) >= 0; };

    public static getReel(ID:number):ReelEngineController{
        for(var searchID:number = 0; searchID < this._reels.length; searchID++)
            if(this._reels[searchID].reelID == ID) return this._reels[searchID];
        debugger;
        throw console.error("Can't find the reel with ID: "+ ID);
    };

    constructor(reelAmount:number, config:IReelConfig, initData:any, juri_time_calc:(value:number) => number) {
        super();

        this.reelConfig = config;

        ReelEngineManager.jurisdiction_time_calculator = juri_time_calc;

        this.init(reelAmount, initData);
    };

    protected createReel(ID:number, initData:any):ReelEngineController{
        return new ReelEngineController(ID,this.reelConfig, initData);
    }

    public static remainingStartEngineOffset():number{
        let largestValue:number = 0;
        const id:number = ReelEngineManager.findReelWithState(ReelState.START);
        if(id >= 0) largestValue = Math.max(1/60, this.getReel(id).engine.timeLeft) 
        return largestValue;
    }

    protected init(amount:number, initData:any):void{

        this.AllReels.push(...ArrayHelper.initArrayWithValues(amount,(indx:number) => this.addChild(this.createReel(indx, initData))))

        ReelEngineManager.durations = this.reelConfig.DURATION;

        this.onResize();
    }

    public setQuickStop(val:boolean):void{
        if(!!val) this.AllReels.forEach((reel:ReelEngineController) => reel.isQuickStop = val)
    }

    public static parseData(data: any):void{ this.AllReels.forEach(reel => { reel.parseData(data); }); }

    public static onBeforeSpinStart():void{
        this.isQuickStop = false;
        this.stopOrderIndx = 0;
    };

    public static set isQuickStop(val:boolean) {
        this.AllReels.forEach((reel:ReelEngineController) => reel.isQuickStop = val)
    }

    public static get isQuickStop():boolean{
        for(let r:number = 0; r < this.AllReels.length; r++){
            if(this.AllReels[r].isQuickStop) return true;
        }
        return false;
    }

    public static RAll( func:(rc:ReelEngineController) => void):void  {
        for(let reel:number = 0; reel < this.AllReels.length;reel++){
            func(this.AllReels[reel]);
        }
    };

    public static RSAll(func:(rc:ReelEngineController,sym:PIXI.DisplayObject) => void): void  {
        this.RAll( (rc:ReelEngineController) => {
            for(let row:number = 0; row < rc.AllSymbols.length;row++)
                func(rc, rc.AllSymbols[row]);
        });
    };

    public static RSWindow(func:(rc:ReelEngineController, sym:PIXI.DisplayObject) => void):void  {
        this.RAll( (rc:ReelEngineController) => {
            for(let symID:number = 0; symID < rc.currentWindowAmount;symID++)
                func(rc, rc.AllWindowSymbols[symID]);
        });
    };

    public static nextReelID(reelID:number): number {
        for(let r:number = reelID+1; reelID < this.AllReels.length;reelID++ )
            if(r < this.AllReels.length) return r;
        return -1;
    };

    public static isOnStepOrIdleState():boolean {

        for (let i:number = 0; i < this.AllReels.length; i++) {
            if(this.AllReels[i].isActive && (!this.AllReels[i].state.equal(ReelState.IDLE) && !this.AllReels[i].state.equal(ReelState.STEP)))
                return false;
        }
       
        return true;
    };

    public static findReelWithState(state:string, first:boolean = true, ignoreStep:number = 0):number {
        if(first){
            for (let i:number = 0; i < this.AllReels.length; i++) {
                if(this.AllReels[i].isActive && this.AllReels[i].state.equal(state))
                if(ignoreStep == 0) return this.AllReels[i].reelID; else  --ignoreStep;
            }
        }else{
            for (let i:number = this.AllReels.length-1; i >= 0; i--) {
                if(this.AllReels[i].isActive && this.AllReels[i].state.equal(state))
                if(ignoreStep == 0) return this.AllReels[i].reelID; else  --ignoreStep;
            }
        }
        return -1;
    };

    public static fetchAllReelIDWithState(state:string, first:boolean = true, ignoreStep:number = 0):number[] {
        const arr:number[] = [];
        if(first){
            for (let i:number = 0; i < this.AllReels.length; i++) {
                if(this.AllReels[i].isActive && this.AllReels[i].state.equal(state))
                if(ignoreStep == 0)  arr.push(this.AllReels[i].reelID); else  --ignoreStep;
            }
        }else{
            for (let i:number = this.AllReels.length-1; i >= 0; i--) {
                if(this.AllReels[i].isActive && this.AllReels[i].state.equal(state))
                if(ignoreStep == 0)  arr.push(this.AllReels[i].reelID); else  --ignoreStep;
            }
        }
        return arr;
    };

    public static fetchAllStoppingReels(first:boolean = true, ignoreStep:number = 0):number[] {
        const arr:number[] = [];
        if(first){
            for (let i:number = 0; i < this.AllReels.length; i++) {
                if(this.AllReels[i].isActive && this.AllReels[i].state.isStopping)
                if(ignoreStep == 0)  arr.push(this.AllReels[i].reelID); else  --ignoreStep;
            }
        }else{
            for (let i:number = this.AllReels.length-1; i >= 0; i--) {
                if(this.AllReels[i].isActive && this.AllReels[i].state.isStopping)
                if(ignoreStep == 0)  arr.push(this.AllReels[i].reelID); else  --ignoreStep;
            }
        }
        return arr;
    };

    public static get remainingAnimatedReelTime():number {
        for (let i:number = 0; i < this.AllReels.length; i++){
            if(this.AllReels[i].isActive && this.AllReels[i].playTimeLeft){
                return this.AllReels[i].playTimeLeft;
            }
        }
        return 0;
    };

    public static findLatestStop():number {

        const normalStop:number = this.findReelWithState(ReelState.STOP, false);
        if(normalStop >= 0) return normalStop;
        const fastStop:number = this.findReelWithState(ReelState.FAST_STOP, false);
        if(fastStop >= 0) return fastStop;
        const quickStop:number = this.findReelWithState(ReelState.QUICK_STOP, false);
        if(quickStop >= 0) return quickStop;

        return -1;
    };

    public static getFirstStoppingReel():number{
        for (var i = 0; i < this.AllReels.length; i++) {
            if(this.AllReels[i].isActive && this.AllReels[i].state.isStopping) return this.AllReels[i].reelID;
        }
        return -1;
    }

    public static stopReels(delays: number[], _stopOrder?:number[]): void {
        const restDurr: number = ReelEngineManager.jurisdiction_time_calculator(Math.max(...delays) + this.lastSpinningTime) + 0.017;
        if (restDurr > 0) for (let i: number = 0; i < delays.length; i++) delays[i] += restDurr;

        this.stopOrder = [];
        this.stopOrderIndx = 0;

        if(_stopOrder){
            this.stopOrder =_stopOrder;
            this.stopDelays = ArrayHelper.initArrayWithValues(_stopOrder.length,(i) => delays[_stopOrder[i]]) ;
        }else{
            this.AllReels.forEach(rc => {
                if(rc.isActive && rc.state.isSpinning) this.stopOrder.push(rc.reelID)
            })
            this.stopDelays = delays;
        }
        
        this.stopNextReel();
    }

    // When the reels are spinning. The time between the Step and Stop can shift frame by frame.
    // This makes it impossible to calculate the perfect stop between reels without any of them stopping before one or the another.
    // To solve this, the the EngineManager will help the controllers to stop at the correct order no matter what.
    protected static tlStop: gsap.core.Timeline;
    protected static stopNextReel(): void {
        // if(this.isQuickStop) debugger;
        // Fetch the next Reel which is in the current "Step"-state, it goes from 0-n and return -1 if there is nothing.
        const steppingID = this.stopOrder[this.stopOrderIndx] != undefined ? this.stopOrder[this.stopOrderIndx] : -1;
        const latestStop = this.stopOrder[this.stopOrderIndx-1] != undefined ? this.stopOrder[this.stopOrderIndx-1] : -1;

        this.stopOrderIndx++;

        // If there is a Step that should be stopped, trigger. Otherwise, skip and do nothing.
        if (steppingID >= 0) {
            const lastDelay:number = this.stopDelays[latestStop] ? this.stopDelays[latestStop] : 0;
            const nextDelay:number = this.stopDelays[steppingID] ? this.stopDelays[steppingID] : 0;

            const delay: number = nextDelay - lastDelay;
            // If Quickstop triggers, abort the current tl and replace it with a new one.
            this.tlStop = Helper.setTimeline(this.tlStop, new gsap.core.Timeline({
                onComplete: () => this.doNextStop(steppingID)
            }));
            // Get the extra delay from the current stopping reel from it's ongoing step -> stop transition.
            this.tlStop.to(this, { duration: delay  },0);
            // If something is stopping, and the next one haven't stopped and have stop duration diff. Apply the offset so they still stop correctly.
            if(latestStop >= 0){
                if(this.getReel(latestStop)!.playTimeLeft > this.getReel(steppingID)!.engine.nextPlayDuration){
                    const restQuickStopOffset:number = Math.abs((this.getReel(latestStop)!.playTimeLeft - this.getReel(steppingID)!.engine.nextPlayDuration));
                    this.tlStop.to(this, { duration: delay + restQuickStopOffset },0);
                }
            }

            if(!this.tlStop.totalDuration()) {
                this.doNextStop(steppingID);
                // this.tlStop.to(this,{duration: Math.max(1/240,this.getReel(steppingID).playTimeLeft % this.getReel(steppingID).stopDuration) })
            };
        }else {
        } 
    }

    private static doNextStop(steppingID:number):void{
        this.getReel(steppingID).stopSpin();
        this.stopNextReel();
    }

    public static get lastStopOrder(): number {
        return ArrayHelper.fetchLastValue(this.stopOrder)
    }

    public static get lastSpinningReel():ReelEngineController | undefined{
        for(let r:number = this.AllReels.length-1;r; r--)
            if(this.getReel(r).isActive && this.getReel(r).state.isSpinning && this.getReel(r).engine.isActive)
                return this.getReel(r);

        return undefined;
    }

    public static get lastSpinningTime(): number {
        const rc: ReelEngineController | undefined = this.lastSpinningReel;
        return rc ? (rc.nextPlayDuration > rc.playTimeLeft ? rc.nextPlayDuration : rc.playTimeLeft) : 0;
    }

    public getSymPos(ReelID: number,SymID:number): PIXI.Point {
        return MathHelper.pointAdd(this.position, ReelEngineManager.getReel(ReelID).symPos(SymID));
    };

    onResize():void{
        this.AllReels.forEach((reel) => { reel.onResize();});
        this.position = this.dim.position;
        this.scale = this.dim.scale;
    }
}